import omit from 'lodash/omit'
import { schema, setCellAttrs } from 'prose-core'
import { DOMOutputSpec, DOMSerializer, MarkSpec, NodeSpec } from 'prosemirror-model'
import { cellAttrs } from './table'

export const nerudaDomSerializer = (): DOMSerializer => {
  return new DOMSerializer(
    {
      ...pluckToDomFrom(omit(schema.nodes, ['doc', 'text'])),
      text: (node) => node.text as DOMOutputSpec,
      table_cell: (node) => ['td', setCellAttrs(node, cellAttrs), 0],
      table_header: (node) => ['th', setCellAttrs(node, cellAttrs), 0],
    },
    pluckToDomFrom(schema.marks),
  )
}

const pluckToDomFrom = (nodesOrMarks: NodeSpec | MarkSpec) => {
  return Object.fromEntries(
    Object.entries(nodesOrMarks).flatMap(([nodeName, nodeType]) => {
      if (!nodeType.spec.toDOM) return []
      return [[nodeName, nodeType.spec.toDOM]]
    }),
  )
}
